import React from "react";
import { Skeleton } from "@mui/material";
import Grid from '@mui/material/Grid2';
import Container from "@mui/material/Container";

const OrgDashSkeleton = ({lg = 8}) => {

    return (
        <>
                <Grid container spacing={2} justifyContent="center" style={{marginTop:100,marginBottom:50}}>
                    <Grid item size={{xs:12,lg:lg}}>
                        <Grid container spacing={2}>
                            <Grid item size={12} className="flex-space">
                                <Skeleton
                                    variant="rectangular"
                                    width={120}
                                    height={40}
                                    animation="wave"
                                    style={{borderRadius:16}}
                                />
                                <Skeleton
                                    variant="rectangular"
                                    width={70}
                                    height={40}
                                    animation="wave"
                                    style={{borderRadius:16}}
                                />
                            </Grid>
                            <Grid item size={12}>
                                <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height={150}
                                    animation="wave"
                                    style={{borderRadius:16}}
                                />
                            </Grid>
                            <Grid item size={12}>
                                <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height={100}
                                    animation="wave"
                                    style={{borderRadius:16}}
                                />
                            </Grid>
                            <Grid item size={12}>
                                <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height={250}
                                    animation="wave"
                                    style={{borderRadius:16}}
                                />
                            </Grid>
                            <Grid item size={12}>
                                <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height={100}
                                    animation="wave"
                                    style={{borderRadius:16}}
                                />
                            </Grid>

                            <Grid item size={12}>
                                <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height={300}
                                    animation="wave"
                                    style={{borderRadius:16}}
                                />
                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>
        </>


    );
};

export default OrgDashSkeleton;
